module.exports = __webpack_public_path__ + "static/media/home-logo.9875a1ee.svg";